import { interpolateVariables } from "@pathwright/blocks/src/utils/variables"

let Utils
export default Utils = class Utils {
  renderString(string, data) {
    return interpolateVariables(string, data)
  }

  urljoin() {
    const paths = _.map(arguments, (i) => i.replace(/(^\/|\/$)/, ""))
    const path = paths.join("/").replace(/\/{2,}/, "/")
    // If path fragment contained http(s):// the // has been reduced to /
    // Restore the //
    return path.replace(/(http|https)(:\/)/, "$1://")
  }
}
